<script lang="ts" setup>
import type { PropType } from 'vue';
import type { RouteLocationRaw } from 'vue-router';

defineProps({
  text: {
    type: String,
    required: true,
  },
  to: {
    type: [String, Object] as PropType<RouteLocationRaw>,
  },
  prefetch: {
    type: Boolean,
    default: false,
  },
  newTab: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <NuxtLink v-if="to" :to="to" :prefetch="prefetch" :target="newTab ? '_blank' : '_self'">
    <span
      class="underline text-regular c-text-dark hover:c-green-pure transition-colors font-600"
    >
      {{ text }}
    </span>
  </NuxtLink>

  <button v-else class="underline text-regular c-text-dark hover:c-green-pure transition-colors font-600">
    {{ text }}
  </button>
</template>
